import { DefaultTheme } from 'styled-components';

export const lightTheme: DefaultTheme = {
	colors: {
		main: '#FFFFFF',
		background: '#F7F9FE',
		accent: '#693FFF',
		font: '#252A4C',
		disabled: '#C1C1EB',
		moreChart: '#F541F2',
		lightGreen: '#EDFCF3',
		green: '#57DE98',
		lightRed: '#FEEEF5',
		red: '#F04DAD',
	},
};
